module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-39.34d2ced4.png";